export default {
  ADD_TO_CART: 'cart/ADD_TO_CART',
  ADD_TO_CART_START: 'cart/ADD_TO_CART_START',
  ADD_TO_CART_SUCCESS: 'cart/ADD_TO_CART_SUCCESS',
  ADD_TO_CART_FAILURE: 'cart/ADD_TO_CART_FAILURE',

  DELETE_FROM_CART: 'cart/DELETE_FROM_CART',
  REMOVE_FROM_CART_SUCCESS: 'cart/REMOVE_FROM_CART_SUCCESS',

  REMOVE_ALL_INSTANCES: 'cart/REMOVE_ALL_INSTANCES',
  REMOVE_ALL_INSTANCES_SUCCESS: 'cart/REMOVE_ALL_INSTANCES_SUCCESS',
  CLEAR_CART: 'cart/CLEAR_CART',
  CLEAR_CART_SUCCESS: 'cart/CLEAR_CART_SUCCESS',
};
